import { queryClient } from '../services/queryClient';
import { fetchSubjects } from '../services/subject';
import type { ISubjectsResponse, SubjectSearchParams } from '../interface/subjectModel';

/**
 * Non-hook helper for fetching subjects using the shared QueryClient.
 * This is intended for use from non-React code (e.g., Redux thunks).
 */
export const fetchSubjectsQuery = async (
  params?: SubjectSearchParams,
): Promise<ISubjectsResponse> => {
  const data = await queryClient.fetchQuery(
    ['subjects', params],
    async () => await fetchSubjects(params),
    {
      staleTime: 24 * 60 * 60 * 1000,
      cacheTime: 24 * 60 * 60 * 1000,
    },
  );

  return data as ISubjectsResponse;
};

/**
 * Re-export any other shared react-query helpers here in future.
 */
